import axios from "axios";
import { ReactQueryKey, RentalType, UseCustomQueryOptions } from "../../types";
import { useQuery } from "@tanstack/react-query";
import { IProductForCoupon } from "./getCoupon";
import { IGetProductReturn } from "./getProduct";

interface IGetProductQueryParams {
    segment: RentalType,
    productList: IProductForCoupon[],
    leisureCode: string,
    pickUpDate: string,
    tenant: string,
    dealer: string
}

interface IGetProductParams {
    productList: IProductForCoupon[],
    leisureCode: string,
    pickUpDate: string,
    tenant: string,
    dealer: string
}

export const getProductLeisure = async (params: IGetProductParams): Promise<IGetProductReturn> => {
    const response = await axios.post('/booking/instool/productLeisure', params);
    return response.data;
};

export const useProductLeisureQuery = (
    params: IGetProductQueryParams,
    options?: UseCustomQueryOptions<IGetProductReturn>
) => {
    return useQuery<IGetProductReturn>({
        queryKey: [ReactQueryKey.Product, {segment: params.segment, tenant: params.tenant, dealer: params.dealer}],
        enabled: !!params.leisureCode && !!params.productList,
        queryFn: () => getProductLeisure({leisureCode: params.leisureCode, productList: params.productList, pickUpDate: params.pickUpDate, tenant: params.tenant, dealer: params.dealer}),
        ...options
    })
};

export const useProductLeisureObserver = () => {
    return useQuery<IGetProductReturn>({
        queryKey: [ReactQueryKey.Product, {segment: RentalType.RETAIL}],
        enabled: false
    })
};
